module.exports = {
      id: "banner-usage",
      viewBox: "0 0 104.501 104.279",
      url: __webpack_public_path__ + "images/js_src_vue/page_price_versions/sprite.ce6f763a.svg#banner-usage",
      toString: function () {
        return this.url;
      }
    }